import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { EmptyResults } from "components/catalog/EmptyResults";
import useCatalog from "hooks/useCatalog";
import { colors } from "theme";
import { IDesign } from "types/design";

import Row from "./TableRow";

const useStyles = makeStyles((theme: Theme) => ({
  table: { borderCollapse: "separate" },
  header: {
    backgroundColor: "inherit",
    height: 32,
    "& > th.MuiTableCell-head": {
      padding: "8px 24px 8px 16px",
      fontSize: 12,
      lineHeight: "18px",
      letterSpacing: 0.5,
      fontWeight: 600,
      borderBottom: "none",
    },
  },
  spacingRow: {
    height: 16,
    width: "100%",
  },
  suggestedPanelsRow: {
    backgroundColor: "transparent",
    "& > td": {
      padding: "16px 16px 8px 0 !important",
      borderBottomColor: "transparent",
    },
  },
  suggestedPanelsHeader: {
    letterSpacing: 0.25,
  },
  suggestedPanelsSubheader: {
    color: colors.grey[100],
  },
  emptyRow: {
    backgroundColor: "transparent",
    "& > td": {
      borderBottom: "none",
      "& > div": {
        paddingTop: 24,
      },
    },
  },
}));

const SuggestedPanels = () => {
  const { suggestedPanels } = useCatalog();
  const classes = useStyles();

  return (
    <>
      <TableRow className={classes.suggestedPanelsRow}>
        <TableCell colSpan={6} align="center">
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Typography variant="h4" className={classes.suggestedPanelsHeader}>
              Below are our best suggestions based on your targets of interest.
            </Typography>
            <Box mt={1}>
              <Typography
                variant="body2"
                className={classes.suggestedPanelsSubheader}
              >
                If you like what you see, you can customize any suggested panel
                to give it a name, modify it, and request a quote.
              </Typography>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
      <TableRow className={classes.spacingRow} role="presentation" />
      {suggestedPanels.map((row) => (
        <Row key={row.name} row={row as IDesign} canQuote={false} />
      ))}
    </>
  );
};

const EvaluatePanelOptionsTable = () => {
  const { loading, rowsData, suggestedPanels } = useCatalog();
  const classes = useStyles();

  return (
    <>
      <Table
        size="small"
        className={classes.table}
        aria-label="Interactive table of catalog panels and suggested panels that match your target search."
      >
        <TableHead>
          <TableRow className={classes.header}>
            <TableCell>Panel</TableCell>
            <TableCell>Design Type</TableCell>
            <TableCell>Reads</TableCell>
            <TableCell>Matching Genes</TableCell>
            <TableCell>Extra Genes</TableCell>
            <TableCell>Uncovered Genes</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
          {!loading &&
            rowsData.map((row) => <Row key={row.id} row={row as IDesign} />)}
          {!loading && !rowsData.length && (
            <TableRow className={classes.emptyRow}>
              <TableCell colSpan={6} align="center">
                <EmptyResults hideFooterActions />
              </TableCell>
            </TableRow>
          )}
          {suggestedPanels.length > 0 && <SuggestedPanels />}
        </TableBody>
      </Table>
    </>
  );
};

export default EvaluatePanelOptionsTable;
